import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import TherigyInfoMessage from 'App/components/TherigyInfoMessage/TherigyInfoMessage';
import Table from 'App/components/Table';
import pathOrDash from 'App/utils/pathOrDash';
import RowDatePicker from './RowDatePicker';
import RowCustomMenu from './RowCustomMenu';
import RXCell from './RXCell';

const propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    isLoading: PropTypes.bool,
};

const defaultProps = {
    isLoading: false,
};

function getIcd10(row) {
    const icd10Details = row.medication?.icd10?.icd10Details;
    if (icd10Details?.dxCode) {
        return `${icd10Details.dxCode} ${icd10Details.dxDescShort}`;
    }
    return row.icd_10 || '--';
}

function EditReferralMedicationTable({ data, isLoading }) {
    const columns = useMemo(
        () => [
            {
                Header: 'Medication',
                accessor: pathOrDash(['medication', 'name']),
                id: 'medication',
            },
            {
                Header: 'ICD-10',
                accessor: getIcd10,
                id: 'icd_10',
            },
            {
                Header: 'Rx Number',
                accessor: pathOrDash(['rx', 'rxNumber']),
                id: 'rxNumber',
                Cell: RXCell,
            },
            {
                Header: 'Rx Status',
                accessor: 'status',
                Cell: RowCustomMenu,
                id: 'status',
            },
            {
                Header: 'Rx Status Date',
                accessor: 'statusDate',
                Cell: RowDatePicker,
                id: 'statusDate',
            },
        ],
        []
    );

    return (
        <div>
            {data?.length > 0 && !isLoading ? (
                <Table
                    enablePagination={false}
                    columns={columns}
                    data={data}
                    isLoading={isLoading}
                    placeholderText="No Medication"
                />
            ) : (
                <TherigyInfoMessage message="There are currently no medications attached to this referral." />
            )}
        </div>
    );
}

EditReferralMedicationTable.propTypes = propTypes;
EditReferralMedicationTable.defaultProps = defaultProps;

export default EditReferralMedicationTable;
